import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  padding: ${props => (props.isDweb ? '10px 0px' : '10px')};
`;

export const CommonDetails = styled.div`
  padding: 10px 15px;
  line-height: 1.2;
  font-size: 14px;
  color: #666;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 2px 4px 0px;
  border-radius: 10px;
  background-color: #fff;
  h1,
  h2 {
    color: #000000;
    font-size: 2em;
    line-height: 1.5;
    font-weight: bold;
  }
  h3 {
    font-size: 1.17em;
    line-height: 1.13;
    font-weight: bold;
  }
`;

export const Headings = styled.h2`
  padding: 10px 17px;
  color: #000000;
  font-size: ${props => (props.isDweb ? '2em' : '1.5em')};
  line-height: 1.5;
  font-weight: bold;
`;

export const LabelRoutes = styled.div`
  padding: 0 ${props => props.theme.spacing.custom(20)};
`;

export const ContentSectionWrap = styled.div`
  padding: 15px 15px 15px 25px;
  border-right: 5px solid #ddd;
  & .contentHead {
    background: #eee;
    padding: 4px 7px;
    font-size: ${props => (props.isDweb ? '10px' : '12px')};
    font-weight: 700;
    ${props =>
      props.isDweb &&
      css`
        color: #141823;
      `};
  }
  & .contentSection {
    & .searchTabsBtn {
      border: 1px solid #ddd;
      color: #0b69e3;
      font-size: ${props => (props.isDweb ? '10px' : '12px')};
      width: 120px;
      padding: 9px 10px;
      box-sizing: border-box;
      border-radius: 2px;
    }
    & .faqSection {
      border-bottom: 1px solid #e1e7ee;
      padding: 7px 0px;
      &:last-child {
        border: none;
        padding: 7px 0 0 0;
      }
      & .faqArrow {
        border: solid #8e93ab;
        border-width: 0px 2px 2px 0px;
        display: inline-block;
        padding: 2px;
        -webkit-transform: rotate(-45de);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        content: '';
        &.arrowDown {
          border-width: 0px 0px 2px 2px;
        }
      }
    }
  }
  &.contentGreen {
    border-right: 5px solid #14afc5;
    & .contentHead {
      background: rgba(20, 175, 196, 0.1);
      color: #14afc4;
    }
  }
  &.contentDarkBlue {
    border-right: 5px solid #58668d;
    & .contentHead {
      background: rgba(88, 102, 141, 0.1);
      color: #58668d;
    }
  }
  &.contentBrown {
    border-right: 5px solid #a06271;
    & .contentHead {
      background: rgba(160, 98, 113, 0.1);
      color: #a06271;
    }
  }
`;

export const LinkWrap = styled.a`
  flex-basis: content;
  margin: 5px;
  ${props =>
    props.isDweb &&
    css`
      margin: 2px;
    `};
`;
